import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import {
  getStoredToken,
  handleUnauthorized,
  scheduleTokenRefresh,
} from './tokenManager';

const apiCall = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

apiCall.interceptors.request.use(
  (config) => {
    if (config.skipAuth) return config;

    const token =
      typeof window !== "undefined" ? getStoredToken() : null;

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiCall.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err?.response?.status;

    if (status === 401 && !err.config._retry) {
      try {
        return await handleUnauthorized(err.config, apiCall);
      } catch (refreshErr) {
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(err);
  }
);

export default apiCall;
export { scheduleTokenRefresh };
